import { useEffect } from 'react';
import { ErrorShell } from './ErrorShell';

/**
 * 500 — `/500` 라우트로 직접 접근하거나 ErrorBoundary 폴백으로 사용.
 * 이 앱은 BrowserRouter+Routes(비-데이터 라우터) 구조라 `useRouteError()`를 쓸 수 없음
 * (data router 밖에서 호출하면 그 자체로 throw 되어 폴백이 다시 크래시함) — error 는 prop 으로 받는다.
 */
export function ServerErrorPage({ error }: { error?: unknown } = {}) {
  useEffect(() => {
    document.title = '일시적인 오류가 발생했어요 · 시세공간';
    if (error) {
      // 운영 환경에서도 콘솔에는 남겨 디버깅에 활용
      console.error('[ServerError]', error);
    }
  }, [error]);
  return (
    <ErrorShell
      code="500"
      title="일시적인 오류가 발생했어요"
      description="잠시 후 다시 시도해주세요. 문제가 계속되면 고객센터로 문의해주세요."
      hint="문의: norigonggan@gmail.com"
    />
  );
}
